<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
            <v-flex lg12>
              <label class="blackLabel">* Purchase Order Number:</label>
              <v-text-field label="Purchase Order Number" v-model="soNumber" required :rules="soRules" single-line solo></v-text-field>
            </v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<v-progress-circular indeterminate :width="3" style="margin-top: 5px;" :size="20" v-if="loading" color="grey" class="pt-3 loginLoader"></v-progress-circular>
					<v-btn v-if="!loading" color="success" :disabled="fncCheckButton()" class="text-xs-right" @click.stop="fncPrintInvoice()">Print Invoice</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import draggable from 'vuedraggable'
	import DatePicker from 'vue2-datepicker'
	export default {
	  name: 'Settings',
      data() {
        return {
          soNumber: '',
          soRules: [
            v => !!v || 'Sales Order Number is required',
          ],
          loading: false
			};
		},
      methods: {
        fncHideModal() {
          this.$store.commit('hideModal');
        },
        fncCheckButton() {
          if( this.soNumber == '' ) {
            return true;
          }
          return false;
        },
        fncPrintInvoice(){

          this.loading = true;
          var setOrder = this.globalModalParams.order;
          setOrder.setSoNumber = this.soNumber;

          this.$store.dispatch({
            type: 'fncSetQuoteDetails',
            quoteId: setOrder.quoteId,
            quote: setOrder.quoteNo,
            so: true,
            order: setOrder,
            vendorList: this.vendorList,
            privileges: this.objAuthorize.privileges,
            doPrintInvoice: true,
            hasStatus: ''
          });

          /*this.loading = true;
          var setOrder = this.globalModalParams.order;
              setOrder.setSoNumber = this.soNumber;

          this.$store.dispatch({
            type: 'fncSetQuoteDetails',
            quoteId: setOrder.quoteId,
            quote: setOrder.quoteNo,
            so: true,
            order: setOrder,
            vendorList: this.vendorList,
            privileges: this.objAuthorize.privileges,
            doPrintInvoice: true,
            hasStatus: ''
          });*/

        }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'vendorList'
			])
		},
    beforeMount() {
      this.$store.dispatch('fncPopulateVendors');
    }
  }
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
